import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const shopify = {
  products: (market, collection, q) =>
    client.get("/catalog/products", { params: { market, collection, q } }).then(r => r.data.products),
  product: (handle, market) =>
    client.get(`/catalog/products/${handle}`, { params: { market } }).then(r => r.data),
  collections: (market) =>
    client.get("/catalog/collections", { params: { market } }).then(r => r.data.collections),
  collection: (handle, market) =>
    client.get(`/catalog/collections/${handle}`, { params: { market } }).then(r => r.data),
  colorways: (handle, market) =>
    client.get(`/catalog/colorways/${handle}`, { params: { market } }).then(r => r.data.colorways),
  completeTheLook: (handle, market) =>
    client.get(`/catalog/complete-the-look/${handle}`, { params: { market } }).then(r => r.data.items),
  bundlePartner: (handle, market) =>
    client.get(`/catalog/bundle-partner/${handle}`, { params: { market } }).then(r => r.data.partner),
  lookbook: () => client.get("/lookbook").then(r => r.data.entries),
  homepageHero: () => client.get("/homepage-hero").then(r => r.data.hero),
  policies: () => client.get("/policies").then(r => r.data.policies),
  page: (handle) => client.get(`/pages/${handle}`).then(r => r.data),
};

export const cartApi = {
  create: (market) => client.post("/cart", null, { params: { market } }).then(r => r.data),
  get: (id, market = "NO") => client.get("/cart", { params: { id, market } }).then(r => r.data),
  add: (payload) => client.post("/cart/add", payload).then(r => r.data),
  addMultiple: (payload) => client.post("/cart/add-multiple", payload).then(r => r.data),
  update: (payload) => client.post("/cart/update", payload).then(r => r.data),
  remove: (payload) => client.post("/cart/remove", payload).then(r => r.data),
  checkoutUrl: (id, market = "NO") =>
    client.get("/cart/checkout-url", { params: { id, market } }).then(r => r.data.checkout_url),
};

export const wishlistApi = {
  list: (cid) => client.get(`/wishlist/${cid}`).then(r => r.data.items),
  add: (cid, handle) => client.post("/wishlist", { customer_id: cid, product_handle: handle }).then(r => r.data),
  remove: (cid, handle) =>
    client.delete("/wishlist", { params: { customer_id: cid, product_handle: handle } }).then(r => r.data),
};

export const backInStockApi = {
  subscribe: (payload) => client.post("/back-in-stock", payload).then(r => r.data),
};

export const recentlyViewedApi = {
  list: (cid) => client.get(`/recently-viewed/${cid}`).then(r => r.data.items),
  add: (cid, handle) => client.post("/recently-viewed", { customer_id: cid, product_handle: handle }).then(r => r.data),
};

export const newsletterApi = {
  subscribe: (payload) => client.post("/newsletter", payload).then(r => r.data),
};

export default client;
